import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PrinterSettingsService {
    private baseURL: string;

    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    /** Get Rental Printer Settings */
    getRentalPrinterSettings(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/PrinterSettings/GetRentalPrinterSettings`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    /** Save Rental Printer Settings */
    saveRentalPrinterSettings(payload: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/PrinterSettings/SaveRentalPrinterSettings`,
            payload,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    /** Get POS Printer Settings */
    getPOSPrinterSettings(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/PrinterSettings/GetPOSPrinterSettings`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    /** Save POS Printer Settings */
    savePOSPrinterSettings(payload: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/PrinterSettings/SavePOSPrinterSettings`,
            payload,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getThermalPrinters(): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/General/GetListOfValuesByType?typeId=15`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any[]>) => res.body || []),
            catchError(this.handleError)
        );
    }

    /** Error Handler */
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            return throwError(() => error.error.message);
        }
        return throwError(() => error.message || 'Server error');
    }
}
